<div [ngClass]="{ 'vertical-divider': vertical, 'divider': !vertical }" [style.margin]="margin"></div>
